<!--
 * @Author: wsx
 * @Date: 2022-01-05 10:41:50
 * @LastEditTime: 2022-05-11 11:07:22
 * @LastEditors: Please set LastEditors
 * @Description:主菜单
-->
<template>
  <div class="MainMenu" :style="{ background: ' url( ' + topImg + ' ) ' }">
    <!-- background-color="rgba(255,255,255,0)" -->
    <!-- text-color="var(--el-color-white)"
      active-text-color="var(--el-color-primary-light-7)" -->
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      :mode="mode"
      text-color="#fff"
      active-text-color="#12e9f8"
      @select="handleSelect"
      @open="open"
      @close="close"
    >
      <template v-for="item in data" :key="'menu' + item.menuId">
        <menu-tree :menu="item"></menu-tree>
      </template>
    </el-menu>
    <div class="usernameClass" ref="rightBoxRef">
      <div
        @mouseleave="el.isShow ? closeMessage(index, el.code) : ''"
        @mouseover="el.isShow ? showMessage(index, el.code) : ''"
        class="right_box"
        :style="{ position: el.code !== 1 && 'relative' }"
        v-for="(el, index) in rightMenu"
        :key="el.code"
      >
        <div
          v-if="!el.showBadge"
          class="box_con"
          :title="el.title"
          @click="downFile(el.title)"
        >
          <i :class="['iconfont', el.icon]" style="font-size: 24px"></i>
        </div>
        <el-badge v-else :value="el.badgeNum" class="item">
          <div class="box_con" :title="el.title" @click="downFile(el.title)">
            <i :class="['iconfont', el.icon]" style="font-size: 24px"></i>
          </div>
        </el-badge>
        <floatDialog
          v-if="el.code === 1"
          v-model:showFloatDialog="el.showMessageFlag"
          :leftValue="el.leftValue"
          wd="180px"
        >
          <div
            @click="noticeAnnouncement()"
            class="float_item value_item"
            v-for="(item, index) in el.MessageList"
            :key="index"
          >
            <div v-if="!item.menuId" class="rzClass">
              <div class="value_con">
                <i :class="['iconfont', item.icon]"></i>
                <span>{{ item.label }}</span>
              </div>
              <el-badge :value="item.value" :max="99" class="item"></el-badge>
            </div>
            <div
              v-else
              class="rzClass"
              @click.stop="routerClick(item)"
              @mouseover="shouIt(item, true)"
              @mouseleave="shouIt(item, false)"
            >
              <span> {{ item.name }}</span>
              <div class="rzClassBox" v-if="item.list.length !== 0">
                <div class="rzClassItem" v-if="item.list.length !== 0 && show">
                  <div
                    @click="routerClick(it)"
                    v-for="(it, ie) in item.list"
                    :key="ie"
                    class="rzClassIts"
                  >
                    {{ it.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </floatDialog>
        <floatDialogTz
          v-if="el.code === 0"
          v-model:showFloatDialog="el.showMessageFlag"
          :leftValue="el.leftValue"
          @newListNum="getNewListNum"
          wd="240px"
        >
        </floatDialogTz>
      </div>
      <el-dropdown>
        <span
          class="h-dropdown-link"
          @mousemove="open"
          @mouseleave="close(null, ['-1'])"
        >
          你好，{{ name }}
          <h-icon icon="icon-xiangyoujiantou" :rotate="90" />
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-for="item in themeMenu" :key="item.key">
              <el-dropdown-item @click="switchTheme(item.key)">
                <div class="h-dropdown-item">{{ item.name }}</div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog v-model="showNoticeDialog.status" title="消息通知" width="40%">
    </el-dialog>
    <changePassword
      v-if="changePasswordObj.status"
      v-model="changePasswordObj.status"
    ></changePassword>
  </div>
</template>
<script>
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import MenuTree from "./MenuTree.vue";
import { defineComponent, reactive, toRefs, onMounted, ref, inject } from "vue";
import { createContext, useContext } from "@/hooks/core/useContext.js";
import util from "@util/js";
import { initStyle } from "@/hooks/useStyle";
import { logout } from "@/api/login";
import floatDialog from "./component/floatDialog.vue";
import floatDialogTz from "./component/floatDialogTz.vue";
import { notifymessageunread_message } from "@/api/messageCenter/messageCenterApi.js";
export default defineComponent({
  name: "MainMenu",
  components: { MenuTree, floatDialog, floatDialogTz },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const data = reactive({
      show: false,
      system: [],
      lgoinList: window.lgoinList,
      topImg: require("@/assets/images/header/bottom.png"),
      currentRoute: "",
      activeIndex: "Home",
      mode: "horizontal", // vertical
      menuList: [],
      name: "",
      themeMenu: [
        { name: "明亮", key: "simple" },
        // { name: "复古", key: "retro" },
        { name: "护眼", key: "eyehelp" },
        // { name: "海天", key: "haitian" },
        // { name: "深邃", key: "deep" },
        // { name: "暗黑", key: "dark" },
        // { name: "新年", key: "newYear" },
        { name: "修改密码", key: "changePassword" },
        { name: "退出登录", key: "logout" },
      ],
      rightMenu: [
        {
          icon: "icon-shezhi",
          code: 1,
          MessageList: [
            // {
            //   label: "系统日志",
            //   icon: "icon-paixu",
            //   value: 0,
            //   code: "0",
            //   com: "noticeBox",
            // },
          ],
          showMessageFlag: false,
          showBadge: false,
          // isShow: window.lgoinList,
          isShow: true,
          leftValue: "",
        },
        {
          icon: "icon-xiaoxi",
          code: 0,
          isShow: true,
          MessageList: [],
          // [
          //   {
          //     label: "消息发布",
          //     icon: "icon-rili",
          //     value: 0,
          //     code: "0",
          //     com: "noticeBox"
          //   },
          //   {
          //     label: "消息互动",
          //     icon: "icon-invite",
          //     value: 0,
          //     code: "1",
          //     com: "interactiveNews"
          //   },
          //   {
          //     label: "记事本",
          //     icon: "icon-shouye",
          //     value: 0,
          //     code: "2",
          //     com: "notepad"
          //   }
          // ],
          showMessageFlag: false,
          showBadge: true,
          badgeNum: 0,
          leftValue: "",
        },
        {
          icon: "icon-xiazai",
          code: 2,
          MessageList: [],
          showMessageFlag: false,
          showBadge: false,
          isShow: true,
          title: "下载中心",
        },
      ],
      showNoticeDialog: {
        status: false,
      },
      changePasswordObj: {
        status: false,
        info: {},
      },
    });

    const refData = toRefs(data);
    const rightBoxRef = ref(null);
    const router = useRouter();
    const route = useRoute();
    data.name = util.getStorage("name");
    const videoClient = useContext("videoClient");
    data.currentRoute = data.activeIndex = route.name;

    onMounted(() => {
      data.mode = "horizontal";
      switchTheme(window.localStorage.getItem("themeId"));
      data.system = inject("systemss");
      data.rightMenu[0].MessageList = data.rightMenu[0].MessageList.concat(
        data.system.list
      );
    });
    onBeforeRouteUpdate(async (to, from) => {
      data.currentRoute = data.activeIndex = to.name;
    });
    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
      // console.log('%c [ key, keyPath ]-66', 'font-size:13px; background:pink; color:#bf2c9f;', key, keyPath);
    };
    // 点击菜单
    const clickMenu = (menu) => {
      // console.log(menu.url);
      if (menu.url) {
        try {
          if (menu.url == "screenHome/screen") {
            window.open(
              "http://50.136.50.145:6410//#/screenHome/screen",
              "_blank"
            );
          } else if (menu.url.indexOf("http://") !== -1) {
            window.open(menu.url, "_blank");
          } else {
            router.push({ name: menu.url });
          }
        } catch (error) {
          router.push({ name: "404" });
        }
      }
    };
    // 处理视屏控件的显示隐藏
    const open = (index, indexPath, $event) => {
      data.menuOpenState = true;
      setTimeout(() => {
        videoClient.hide();
      }, 100);
    };
    const close = (index, indexPath) => {
      if (indexPath.length === 1) {
        data.menuOpenState = false;
        videoClient.show();
      }
    };
    createContext("menuRoot", {
      clickMenu,
    });
    const switchTheme = (theme) => {
      if (theme === "logout") {
        logout();
        window.localStorage.setItem("active", "");
        util.removeStorage("token");
        util.removeStorage("username");
        util.removeStorage("regionId");
        util.removeStorage("userDeptId");
        router.push("login");
      } else if (theme === "changePassword") {
        data.changePasswordObj.status = true;
      } else {
        initStyle(theme);
      }
      if (theme === "eyehelp") {
        data.topImg = require("@/assets/images/header/bottom2.png");
        context.emit("themeeyehelp");
      }
    };
    const showMessage = (index) => {
      data.rightMenu[index].leftValue =
        rightBoxRef.value.offsetLeft + 55 * index + "px";
      data.rightMenu[index].showMessageFlag = true;
      setTimeout(() => {
        videoClient.hide();
      }, 100);
    };
    const closeMessage = (index) => {
      data.rightMenu[index].showMessageFlag = false;
      videoClient.show();
    };
    const shouIt = (item, is) => {
      if (item.list.length !== 0) {
        data.show = is;
      }
    };
    const noticeAnnouncement = () => {
      data.showNoticeDialog.status = true;
    };
    const routerClick = (item) => {
      if (item.url !== "") {
        router.push({ name: item.url });
      }
    };
    const downFile = (value) => {
      if (value !== "下载中心") return;
      router.push("downCenter");
    };
    const getNewListNum = (value) => {
      console.log(value);
      data.rightMenu[1].badgeNum = value;
    };

    // getNotifyMessage();
    return {
      shouIt,
      ...refData,
      routerClick,
      rightBoxRef,
      switchTheme,
      handleSelect,
      open,
      close,
      closeMessage,
      showMessage,
      noticeAnnouncement,
      downFile,
      getNewListNum,
    };
  },
});
</script>
<style lang="scss">
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #12e9f8 !important;
  background-color: transparent !important;
}

.el-popper {
  // background: transparent !important ;
  border: none !important;

  .el-menu--popup {
    border: none !important;
    background-color: transparent !important;
    background-image: url("~@/assets/images/header/shang.png"),
      url("~@/assets/images/header/xia.png") !important;
    background-repeat: repeat-x, repeat-x !important;
    background-position: 0 0, 0 100% !important;
    background-size: 100% !important;
    padding-top: 16px !important;
    padding-bottom: 16px;
    .el-menu-item {
      background: url("~@/assets/images/header/zhong.png") repeat !important;
      background-size: 100% !important;
    }
    .el-sub-menu__title {
      background: url("~@/assets/images/header/zhong.png") repeat !important;
      background-size: 100% !important;
    }
  }
}
.el-select__popper {
  background: var(--el-color-white) !important;
  border: 1px solid var(--el-border-color-light) !important;
}
</style>
<style lang="scss" scoped>
.MainMenu {
  margin: 0;
  width: 100%;
  height: 100%;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  background-size: 100% 100%;
  display: flex;
  // position: relative;
  // padding: 0 4% 0 5.1%;
  z-index: 3;
  // background-color: var(--el-color-primary);
  // background-image: url("~@/assets/images/bottomBg.png");
  // background-size: 100% 100%;
  // @include flex-row-c-c;
  // overflow-x: hidden;
  // overflow-y: auto;
  .usernameClass {
    display: flex;
    align-items: center;
    // .action_right {
    //   height: 100%;
    //   @include flex-row-s-c;
    //   font-size: 14px;
    .right_box {
      font-size: 14px;
      height: 100%;
      border-left: 2px solid var(--header-padding-color);
      padding: 0 16px;
      cursor: pointer;
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      &.personal_ {
        min-width: 11.88vw;
      }
      &.search_box {
        cursor: inherit;
        &:hover {
          background: none;
        }
      }
      @include flex-row-c-c;
      &:first-child {
        border-left: none;
      }
      .search {
        width: 9.38vw;
        height: 3vh;
      }
      .float_item + .float_item {
        border-top: 1px solid #f5f5f5;
      }
      .float_item {
        width: 100%;
        height: 4vh;
        line-height: 4vh;
        color: #000;
        z-index: 1000;
        .rzClass {
          @include flex-row-c-c;
          position: relative;
          width: 100%;
          .rzClassBox {
            height: 155px;
            width: 60%;
            position: absolute;
            left: -100px;
            top: 0;
            .rzClassItem {
              box-shadow: 0 0 5px rgb(0, 0, 0 / 5%);
              width: 100px;
              height: 150px;
              position: absolute;
              left: -0px;
              top: 0;
              background: white;
              text-align: center;
              border-radius: 10%;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              .rzClassIts {
                &:hover {
                  background: rgba(56, 143, 243, 0.05);
                }
              }
              .rzClassIts + .rzClassIts {
                border-top: 1px solid #f5f5f5;
              }
            }
          }
        }
        &:hover {
          background: rgba(56, 143, 243, 0.05);
          // color: #000;
        }
        &.value_item {
          padding-right: 1vw;
          @include flex-row-sb-c;
        }
        .el-badge {
          @include flex-row-c-c;
        }
        cursor: pointer;
        i {
          margin: 0 0.52vw 0 1vw;
        }
      }
    }
    // }
    .h-dropdown-link {
      cursor: pointer;
      @include flex-row-c-c;
      width: 140px;
      color: var(--el-color-white);
    }
    :deep(.h-dropdown-item) {
      width: 100%;
      text-align: center;
    }
    .weather {
      height: 34px;
      width: 46px;
      // background-image: url('~@/assets/images/weather.png')
    }
  }
  .el-menu-demo {
    min-width: 50%;
    // flex: 1;
  }
  .el-menu--horizontal {
    display: flex;
    justify-content: center;
    border-bottom: none;
    background: transparent;
  }
  :deep(.el-menu) {
    height: 100%;
    width: 100%;
    // color: var(--el-color-white)!important;
    // background-color: rgba($color: #000000, $alpha: 0)!important;
    // .el-menu--horizontal>.el-menu-item{
    //   color: var(--el-color-white);
    // }
  }
  :deep(.el-menu--horizontal .el-menu-item:not(.is-disabled):hover),
  :deep(.el-menu--horizontal .el-menu-item:not(.is-disabled):focus) {
    background-color: transparent;
  }
  // :deep(.el-menu--horizontal>.el-menu-item),
  // :deep(.el-menu--horizontal>.el-sub-menu .el-sub-menu__title){
  //   color: var(--el-color-white);

  // }
  :deep(.el-menu--horizontal > .el-sub-menu .el-sub-menu__title:hover) {
    background-color: transparent;
    color: #12e9f8 !important;
    border-bottom-color: rgb(18, 233, 248) !important;
  }
  .bottomItem {
    width: calc(100% / 3);
    text-align: center;
    cursor: pointer;
    position: relative;
    height: 100%;
    overflow: hidden;
    @include flex-col-c-c;
    &::after {
      width: 80%;
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background-color: #46def2;
    }
    &:before {
      width: 0;
      height: 0;
      box-shadow: 0 0 80px 35px #46def2;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      z-index: -1;
      margin: auto;
    }
    &:hover,
    &.current {
      &::after {
        content: "";
      }
      &:before {
        content: "";
      }
    }
  }
}
</style>
